import logo from '../../assets/images/logo-minimal-white.png';

import { Container, Logo } from './styles';

export const Loading = () => (
  <Container className="loading">
    <Logo src={logo} alt="logo" />
  </Container>
);
